<script>
    export let message;
    export let type = "error";
    export let style;
</script>

<div class="message {type}" {style}>
    {#if message}
        {message}
    {:else}
        <slot></slot>
    {/if}
</div>

<style>
    :global(.message:not(:blank), .message > span[slot]:not(:blank)) {
        color: white;
        padding: 15px 10px;
        margin-bottom: 15px;
    }

    .error.message {
        background: #c00;
        color: white;
    }
</style>